
export default {
  name: "Promotion",
  props: {
    item: {
      type: Object,
      required: true,
    },
    property: {
      type: Object,
      required: true,
    },
    single: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    startDate() {
      if (
        this.item.valid_from &&
        this.$moment(this.item.valid_from).isAfter(this.$moment())
      ) {
        return this.item.valid_from;
      }

      return this.$moment().format("YYYY-MM-DD");
    },
    endDate() {
      return this.$moment(this.startDate).add(1, "day").format("YYYY-MM-DD");
    },
  },
};
